var _a, _b;
import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { CarouselHeightDesktop, CarouselWidthDesktop, EaseAnimation, mediaQuery, } from './Constants';
export var useFirstRunControlStyles = makeStyles({
    fluentProvider: {
        backgroundColor: 'transparent',
    },
    container: (_a = {
            transform: 'scale(0.7)',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            position: 'relative',
            letterSpacing: '0.25px',
            transitionDuration: '1200ms',
            transitionProperty: 'all',
            msTransitionTimingFunction: EaseAnimation
        },
        _a[mediaQuery.minMedium] = {
            flexDirection: 'row',
        },
        _a),
    containerActive: {
        transform: 'scale(1.0)',
    },
    content: __assign(__assign({ zIndex: '200', width: '100%', maxWidth: "".concat(CarouselWidthDesktop, "px"), backgroundColor: tokens.colorNeutralBackground1, color: tokens.colorNeutralForeground1, boxShadow: tokens.shadow64 }, shorthands.borderRadius('8px')), (_b = { display: 'grid', gridTemplateRows: '62px 1fr 48px', '@media only screen and (min-width: 640px) and (max-width: 1023px)': {
                width: '528px',
            } }, _b[mediaQuery.minLarge] = {
        gridTemplateRows: '62px 1fr 72px',
    }, _b[mediaQuery.minExtraLarge] = {
        minHeight: "".concat(CarouselHeightDesktop, "px"),
        width: '850px',
    }, _b)),
    header: __assign({}, shorthands.padding('20px', '24px')),
    image: {
        height: '22px',
    },
    slideContent: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
});
//# sourceMappingURL=FirstRunControl.styles.js.map